/**
 * ImageBanner 스타일
 * @description 배너 한 장은 `Media` 의 panorama 비율(2.33:1)을 쓰고, 모서리는 여기서
 *   클리핑 상자로 입힌다 — `Media` 는 radius 를 갖지 않는 컴포넌트다(ContentCard 와 같은 방식).
 *   가로 여백이 없다. 담는 쪽이 정한다.
 *
 *   넘김 버튼은 폰 폭에서 그리지 않는다 — 손가락으로 넘기는 자리에 버튼을 겹치면 시안에
 *   없던 것이 이미지를 가린다. 마우스가 있는 폭부터 세운다.
 */
export const imageBannerStyles = {
  root: "flex w-full flex-col gap-[var(--fw-space-gap-sm)]",
  frame: "group relative w-full",
  track: [
    "flex w-full snap-x snap-mandatory overflow-x-auto rounded-[var(--fw-radius-xl)]",
    "[scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
  ].join(" "),
  /**
   * 한 페이지 — 폭은 상자 폭 그대로다. `group/page` 와 `data-active` 로 내용이 "지금 보이는
   * 장" 을 알 수 있다 — 글자 등장·그림 움직임 같은 장식이 그 신호를 읽는다.
   */
  page: "group/page w-full shrink-0 snap-start",
  control: "absolute top-1/2 hidden -translate-y-1/2 tablet:block",
  controlPrevious: "left-[var(--fw-space-inset-lg)]",
  controlNext: "right-[var(--fw-space-inset-lg)]",
};
